import { Slideover } from 'tailwindcss-stimulus-components'

export default class extends Slideover {
  declare readonly dialogTarget: HTMLDialogElement

  backdropClose (event: any): void {
    if (event.target.nodeName === 'DIALOG' && event.target === this.dialogTarget) {
      super.backdropClose(event)
      this.reloadIfRequested()
    }
  }

  close (): void {
    super.close()
    this.reloadIfRequested()
  }

  private reloadIfRequested (): void {
    const shouldReload = this.dialogTarget?.dataset?.reloadPage === 'true'

    if (shouldReload) {
      requestAnimationFrame(() => { window.location.reload() })
    }
  }
}
